import mountApp from 'cfg/mountApp';
import Faq      from './Faq.vue';


export default {

  render(selector, options = {}) {
    return mountApp({
      ...options,
      translationDomain: 'faq',
      components: { Faq },
    }, `#${selector}`);
  },

};
